// extracted by mini-css-extract-plugin
module.exports = {"button":"_2kP4J","medium":"_3CC0H","text":"R4cZE","icon":"YygTs"};